import { Directive, OnInit } from '@angular/core';
import { GoogleComponent } from '@pages/utils/google.component';
import { take } from 'rxjs/operators';
import { PainelManutencoesService } from 'src/app/services/painel-manutencoes.service';
import { buildPaginationItems, PaginationItem } from 'src/app/utils/pagination.utils';

@Directive()
export abstract class ManutencaoBaseComponent extends GoogleComponent implements OnInit {

  public dados: any = null;
  public idEmpresaLogada: string;
  public campoInput: string = '';
  public buscaFiltrada: boolean = false;
  public pagina: number = 0;
  public tamanho: string = '9';
  public itensPaginacao: PaginationItem[] = [];

  public alertConfirmacao: boolean = false;
  public loadingDelete = false;
  public alertSucesso: boolean = false;
  public alertError: boolean = false;

  protected tipoExclusao: string;
  protected codigoExcluir: string;

  protected abstract readonly sectionApp: string;
  protected abstract readonly screenName: string;
  protected abstract readonly screenType: string;
  protected abstract readonly inputName: string;

  constructor(protected readonly service: PainelManutencoesService) {
    super();
  }

  ngOnInit(): void {
    this.idEmpresaLogada = localStorage.idEmpresaLogada;
    this.consultar();
  }

  addTagManagerInteraction(elementType: string, elementContent: string) {
    return this.buildTagInteraction(elementType, elementContent, this.sectionApp, this.screenName, this.screenType);
  }

  protected abstract excluirUnico(codigo: string): void;

  consultar() {
    this.service.getProdutos(this.idEmpresaLogada, this.pagina, this.tamanho, this.campoInput)
      .pipe(take(1)).subscribe({
      next: (response: any) => {
        if (response.status == 'OK' && response.response.data?.length) {
          this.dados = response.response;
          this.configsPaginacao();
        } else {
          this.dados = undefined;
        }
      },
      error: (erro: any) => { this.dados = false; console.error(erro); }
    });
  }

  protected excluirSelecionados() {
    const checkboxes: any = document.querySelectorAll(`input[name="${this.inputName}"]:checked`);
    if (!checkboxes?.length) return;

    let query = '';
    for (const input of checkboxes) { query += `codigosBeneficioArquivo=${input.id}&`; }
    if (checkboxes.length == this.dados.data.length) this.pagina = 0;

    this.loadingDelete = true;
    this.service.deleteAllProdutos(this.idEmpresaLogada, query).pipe(take(1)).subscribe({
      next: (r: any) => this.handleDeleteResponse(r, () => this.consultar()),
      error: (e: any) => this.handleDeleteError(e)
    });
  }

  buscaFiltradaPorInput() {
    if (this.campoInput?.length) {
      this.buscaFiltrada = true;
      this.consultar();
    }
  }

  limparFiltro() {
    this.buscaFiltrada = false;
    this.campoInput = '';
    this.consultar();
  }

  selecionaTodos(input: any) {
    document.querySelectorAll("input[type='checkbox']").forEach((item: any) => { item.checked = input.checked; });
  }

  configsPaginacao() {
    this.itensPaginacao = buildPaginationItems(this.pagina, this.dados.pageRequest.totalPages);
  }

  alteraPagina(numeroPagina: any) {
    if (this.pagina != numeroPagina && numeroPagina != '...') {
      this.pagina = numeroPagina;
      this.dados = null;
      this.consultar();
    }
  }

  alteraQuantidadePorPagina() {
    this.pagina = 0;
    this.dados = null;
    this.consultar();
  }

  protected handleDeleteResponse(response: any, recarregar: () => void) {
    this.loadingDelete = false;
    if (response.status === 'OK') {
      this.alertSucesso = true;
      recarregar();
    } else {
      this.alertError = true;
    }
  }

  protected handleDeleteError(erro: any) {
    this.loadingDelete = false;
    this.alertError = true;
    console.error(erro);
  }

  showAlertConfirmacao(tipo: string, codigo: string) {
    this.alertConfirmacao = true;
    this.tipoExclusao = tipo;
    if (tipo === 'excluirUnico') {
      this.codigoExcluir = codigo;
    }
    if (tipo === 'excluirSelecionados') {
      const checkboxes: any = document.querySelectorAll(`input[name="${this.inputName}"]:checked`);
      if (checkboxes?.length) {
        this.onTagExcluirSelecionados(checkboxes);
      }
    }
  }

  protected abstract onTagExcluirSelecionados(checkboxes: any): void;

  fecharAlertConfirmacao(acao: string) {
    this.alertConfirmacao = false;
    if (acao === 'Confirmar') {
      if (this.tipoExclusao === 'excluirSelecionados') {
        this.excluirSelecionados();
      } else {
        this.excluirUnico(this.codigoExcluir);
      }
    }
  }

  fecharAlertSucesso(_: string) { this.alertSucesso = false; }
  fecharAlertError(_: string) { this.alertError = false; }
}
